import { AUTH_PREFIX_PATH, LANDING_PREFIX_PATH } from 'configs/AppConfig';
import useDomain from 'hooks/useDomain';
import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import AuthViews from 'views/auth-views';

export const AuthLayout = () => {
	const { domainData } = useDomain();
	const { pathname } = useLocation();

	return (
		<div className="min-h-screen w-screen flex items-center justify-center bg-slate-50 relative overflow-hidden p-4 md:p-6 lg:p-8">
			{/* Ambient Glowing Blobs */}
			<div className="absolute top-[-10%] left-[-10%] w-[45vw] h-[45vw] bg-monko-300/25 rounded-full blur-[100px] pointer-events-none animate-pulse" style={{ animationDuration: '8s' }} />
			<div className="absolute bottom-[-10%] right-[-10%] w-[50vw] h-[50vw] bg-monko/15 rounded-full blur-[120px] pointer-events-none animate-pulse" style={{ animationDuration: '10s' }} />
			
			{/* Skew Pattern Overlay */}
			<div className="absolute inset-0 bg-skew-pattern opacity-[0.02] pointer-events-none" />

			<div className="relative z-10 w-full max-w-[500px]">
				<div className="bg-white/80 backdrop-blur-xl border border-white/60 shadow-[0_20px_50px_rgba(46,74,90,0.06)] rounded-[2.5rem] overflow-hidden transition-all duration-300">
					<div className="px-8 pt-10 pb-6 flex flex-col items-center">
						<Link to={LANDING_PREFIX_PATH} className="transition-transform duration-300 hover:scale-105 mb-6">
							<img
								alt="Monko"
								className="h-16 w-auto object-contain"
								src={domainData.logo}
							/>
						</Link>

						{/* Premium Sliding Toggler */}
						<div className="p-1 inline-flex bg-slate-100/80 backdrop-blur-sm border border-slate-200/30 rounded-2xl shadow-inner w-full max-w-[320px]">
							<Link
								to={`${AUTH_PREFIX_PATH}/login`}
								className={`flex-1 text-center py-2.5 text-sm font-semibold rounded-xl transition-all duration-200 ${
									pathname === `${AUTH_PREFIX_PATH}/login`
										? "bg-white text-slate-800 shadow-md shadow-slate-200/50"
										: "text-slate-500 hover:text-slate-700 hover:bg-white/50"
								}`}
							>
								Нэвтрэх
							</Link>
							<Link
								to={`${AUTH_PREFIX_PATH}/register`}
								className={`flex-1 text-center py-2.5 text-sm font-semibold rounded-xl transition-all duration-200 ${
									pathname === `${AUTH_PREFIX_PATH}/register`
										? "bg-white text-slate-800 shadow-md shadow-slate-200/50"
										: "text-slate-500 hover:text-slate-700 hover:bg-white/50"
								}`}
							>
								Бүртгүүлэх
							</Link>
						</div>
					</div>

					<div className="px-8 md:px-10 pb-10">
						<Switch>
							<Route path={`${AUTH_PREFIX_PATH}/`} component={AuthViews} />
						</Switch>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AuthLayout;
